module.exports = __webpack_public_path__ + "static/img/local-level.cc56b19f.png";